import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../../config/config.js";
import LinkItem from "./LinkItem";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogOut, reset } from "../../../features/authSlice.js";

const isLogoutItem = (item) =>
  String(item?.items_menu_bar?.name || "").trim().toLowerCase() === "logout";

const Sidebar = ({ isSidebarOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [menuItems, setMenuItems] = useState([]);

  const orderedMenuItems = useMemo(
    () => [
      ...menuItems.filter((item) => !isLogoutItem(item)),
      ...menuItems.filter(isLogoutItem),
    ],
    [menuItems]
  );

  const logout = () => {
    dispatch(LogOut());
    dispatch(reset());
    navigate("/");
  };

  useEffect(() => {
    const getMenuItems = async () => {
      const response = await axios.post(`${API_BASE_URL}/menu_items`, {
        iduser: user.iduser,
      });
      setMenuItems(response.data);
    };
    if (user) {
      getMenuItems();
    }
  }, [user]);

  return (
    <aside
      className={`fixed top-0 left-0 z-40 w-64 h-screen pt-20 bg-white border-r border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-700 transition-transform ${isSidebarOpen ? " translate-x-0" : "-translate-x-full"
        } `}
    >
      <div className="h-full px-3 pb-4 overflow-y-auto">
        <ul className="space-y-2 font-medium">
          {orderedMenuItems.map((item) => (
            <LinkItem
              key={item.idmenu || item.items_menu_bar?.iditem}
              href={item.items_menu_bar.href}
              text={item.items_menu_bar.name}
              icon={item.items_menu_bar.icon}
              onClick={
                isLogoutItem(item) ? logout : undefined
              }
            />
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
